import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  dateParser,
  dateParserWithoutTime,
  dateParserWithoutTimeAndDate,
} from "../../helper";
// import VersionHistoryAttachments from "./VersionHistoryAttachments";
import VersionHistoryAttachments from "../EmissionLog/EmissionDetailedView/VersionHistoryAttachments";

const OffsetVersionHistory = (props: any) => {
  const [reorderHistory, setReorderHistory] = useState(false);
  const [noOfImagesUpload, setNoOfImagesUpload] = useState(0);
  const [scrollAmount, setScrollAmount] = useState(0);
  const [totalScrollWidth, setTotalScrollWidth] = useState(0);
  const { versionHistoryData } = props;
  const getName = (file: any) => {
    const extensionOfFile = file.originalName.slice(-4);
    const originalFileName = file.originalName?.split("-")[1];

    const splitedName = originalFileName.slice(0, originalFileName.length - 4);
    const requiredName = splitedName + extensionOfFile;
    const ans =
      requiredName?.length > 18
        ? requiredName.slice(0, 8) + "....." + extensionOfFile
        : requiredName;
    return ans;
  };
  const imageSrc: string = "assets/images/doc.png";
  const getPreviewImage = (image: string) => {
    return image?.includes(".jpg") ||
      image?.includes(".jpeg") ||
      image?.includes(".png") ||
      image?.includes(".avif") ||
      image?.includes(".webp")
      ? image
      : imageSrc;
  };
  const slider = useRef<HTMLDivElement | null>(null); // Explicitly type the ref
  let container = slider.current;
  const handleScroll = () => {
    if (container) {
      const currentScrollAmount = container.scrollLeft;
      setScrollAmount(currentScrollAmount);
    }
  };
  const handleContainerWidthChange = (type?: any) => {
    if (container)
      setTotalScrollWidth(
        versionHistoryData?.length * 120 + versionHistoryData?.length * 12
      );
  };
  useEffect(() => {
    container = slider.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      handleContainerWidthChange();
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [container]);
  const handleNext = (type: any) => {
    if (container) {
      const scrollIncrement = window.innerWidth * 0.9;
      if (type === "next") {
        container.scrollLeft += scrollIncrement;
      } else {
        container.scrollLeft -= scrollIncrement;
      }
    }
  };

  const isNextButtonVisible = slider.current
    ? scrollAmount + slider.current.clientWidth < totalScrollWidth
    : false;

  const isPrevButtonVisible = scrollAmount > 0;
  return (
    <Fragment>
      {versionHistoryData?.length ? (
        <div className="flex flex-col pw-detail-main-content  gap-5">
          <div className="pw-version-history">Version History</div>
          <div className="pw-version-history-content pw-border pw-bg-neutral-50 ">
            {/* header */}
            <div className="pw-version-history-header py-2 pw-border-bottom-version-history w-full flex items-center">
              <div style={{ width: "30%" }} className="flex gap-x-4  ml-3">
                <div className="pw-text-neutral-600">Modified on</div>
                <div onClick={() => setReorderHistory(!reorderHistory)}>
                  <img
                    src="assets/icons/sort-alphabetical-descending.svg"
                    alt=""
                  />
                </div>
              </div>
              <div style={{ width: "70%" }} className="pw-text-neutral-600">
                Description
              </div>
            </div>
            <div
              className={`pw-version-history-users pw-bg-white flex ${
                !reorderHistory ? "flex-col" : "flex-col-reverse"
              } items-center `}
            >
              {versionHistoryData.map((eachHistory: any, index: any) => {
                const typeVersion = eachHistory.type;
                return typeVersion === "statusUpdate" ? (
                  <div className="w-full">
                    <div className="flex  w-full mt-2 p-2">
                      <div
                        style={{ width: "30%", paddingRight: "10px" }}
                        className="flex justify-between ml-3   pw-each-history"
                      >
                        <div>
                          <div className="pw-text-neutral-600">
                            {dateParser(eachHistory.created)}
                          </div>
                        </div>
                      </div>

                      {eachHistory?.to_status === "Transferred" && (
                        <div
                          style={{ color: "black", width: "70%" }}
                          className="pw-text-neutral-600 pw-each-history"
                        >
                          <span className="font-bold text-neutral-900 text-sm">
                            {eachHistory?.last_modified_by_name || "Super User"}
                          </span>
                          <span className="pw-word-spacing-2 text-neutral-900 text-sm">
                            {" "}
                            transferred
                          </span>

                          <span
                            className={` text-neutral-900 text-sm font-bold whitespace-nowrap mx-1  p-1`}
                          >
                            {eachHistory.from_value +
                              " " +
                              eachHistory.uom_name}
                          </span>
                          <span className="pw-word-spacing-2 text-neutral-900 text-sm">
                            on
                          </span>
                          <span
                            className={` p-1 whitespace-nowrap mx-1 text-neutral-900 text-sm mr-1`}
                          >
                            {dateParserWithoutTime(eachHistory.transfered_date)}
                            {"."}
                          </span>
                          <span className="pw-word-spacing-2 text-neutral-900 text-sm">
                            The remaining available offset amount is now
                            <span className="font-bold">
                              {" 0 " + eachHistory.uom_name}
                            </span>
                          </span>
                        </div>
                      )}

                      {eachHistory?.to_status !== "Transferred" && (
                        <div
                          style={{ color: "black", width: "70%" }}
                          className="pw-text-neutral-600 pw-each-history"
                        >
                          <span className="font-bold text-neutral-900 text-sm">
                            {eachHistory?.last_modified_by_name || "Super User"}
                          </span>
                          <span className="pw-word-spacing-2 text-neutral-900 text-sm">
                            {" "}
                            {eachHistory?.to_status}
                          </span>

                          <span
                            className={`text-neutral-900 text-sm font-bold whitespace-nowrap mx-1  p-1`}
                          >
                            {eachHistory.from_value -
                              eachHistory.to_value +
                              " " +
                              eachHistory.uom_name}
                          </span>
                          <span className="text-neutral-900 text-sm">
                            for the duration
                          </span>
                          <span className={` mx-1 text-neutral-900 text-sm`}>
                            {dateParserWithoutTimeAndDate(
                              eachHistory.retired_from
                            )}{" "}
                            {"-"}{" "}
                            {dateParserWithoutTimeAndDate(
                              eachHistory.retired_to
                            )}
                            {"."}
                          </span>
                          <span className="pw-word-spacing-2 text-neutral-900 text-sm">
                            The remaining available offset amount is now
                            <span className="font-bold">
                              {" " +
                                eachHistory?.to_value +
                                " " +
                                eachHistory.uom_name}
                            </span>
                          </span>
                        </div>
                      )}
                    </div>
                    {(eachHistory.certificate_number?.length > 0 ||
                      eachHistory.retirement_date ||
                      eachHistory.comments?.length > 0) && (
                      <div
                        style={{
                          width: "100%",
                          justifyContent: "flex-end",
                          padding: "10px",
                        }}
                        className="w-full flex"
                      >
                        <div
                          style={{ width: "69%" }}
                          className="w-full flex flex-col gap-2"
                        >
                          {eachHistory.certificate_number?.length > 0 && (
                            <div className="w-full flex flex-row items-center gap-4">
                              <div className="pw-text-neutral-600 text-sm">
                                Certificate number :{" "}
                              </div>
                              <div className="pw-text-neutral-900 text-sm">
                                {eachHistory.certificate_number || "-"}
                              </div>
                            </div>
                          )}
                          {eachHistory.retirement_date && (
                            <div className="w-full flex flex-row items-center gap-4">
                              <div className="pw-text-neutral-600 text-sm">
                                Retirement date :{" "}
                              </div>
                              <div className="pw-text-neutral-900 text-sm">
                                {dateParser(eachHistory.retirement_date)}
                              </div>
                            </div>
                          )}
                          {eachHistory.comments && (
                            <div className="w-full flex flex-row items-center gap-4">
                              <div className="pw-text-neutral-600 text-sm">
                                Comments :{" "}
                              </div>
                              <div className="pw-text-neutral-900 text-sm">
                                {eachHistory.comments}
                              </div>
                            </div>
                          )}
                          {/* <div className="pw-text-neutral-600 text-sm">Comments : </div>
                          <div className="pw-text-neutral-900 text-sm">
                            {eachHistory.comments || "-"}
                          </div> */}
                        </div>
                      </div>
                    )}

                    {eachHistory?.attachments?.length &&
                      JSON.parse(eachHistory.attachments)?.files?.length >
                        0 && (
                        <VersionHistoryAttachments
                          eachAttachments={
                            eachHistory.attachments?.length &&
                            JSON.parse(eachHistory.attachments)?.files
                          }
                        />
                      )}
                    <div
                      className={` pw-border-bottom-version-history w-full`}
                    ></div>
                  </div>
                ) : (
                  // <Fragment>
                  //   <div
                  //     className={`flex w-full pw-border-bottom-version-history mt-2 p-2`}
                  //   >
                  //     <div
                  //       style={{ width: "30%", paddingRight: "10px" }}
                  //       className="flex justify-between ml-3   pw-each-history"
                  //     >
                  //       <div>
                  //         <div className="pw-text-neutral-600">
                  //           {dateParser(eachHistory.created)}
                  //         </div>
                  //       </div>

                  //       <div style={{ width: "30px", height: "30px" }}>
                  //         <img
                  //           style={{
                  //             width: "100%",
                  //             height: "100%",
                  //             borderRadius: "50%",
                  //             objectFit: "cover",
                  //           }}
                  //           src={
                  //             eachHistory?.ownerProfileImageUrl ||
                  //             "assets/icons/account.svg"
                  //           }
                  //           alt=""
                  //         />
                  //       </div>
                  //     </div>
                  //     {typeVersion === "creation" ? (
                  //       <div
                  //         style={{ color: "black", width: "70%" }}
                  //         className="pw-text-neutral-600 pw-each-history"
                  //       >
                  //         <span className="font-bold text-neutral-900 text-sm">
                  //           {eachHistory?.ownerDisplayName || "Super user"}
                  //         </span>
                  //         <span className="pw-word-spacing-2 text-neutral-900 text-sm">
                  //           {" "}
                  //           Created the log
                  //         </span>
                  //       </div>
                  //     ) : (
                  //       <div
                  //         style={{ color: "black", width: "70%" }}
                  //         className="pw-text-neutral-600 pw-each-history"
                  //       >
                  //         <span className="font-bold text-neutral-900 text-sm ">
                  //           {eachHistory?.ownerDisplayName || "Super user"}
                  //         </span>
                  //         <span className="text-neutral-900 text-sm pw-word-spacing-2">
                  //           {" "}
                  //           update the log value for the emission id
                  //         </span>
                  //         <span className="text-neutral-900 font-bold text-sm">
                  //           &nbsp; {eachHistory?.emission_log}, &nbsp;
                  //         </span>
                  //         <span className="font-bold whitespace-nowrap text-neutral-900 text-sm">
                  //           <span className="font-normal">from</span>{" "}
                  //           {eachHistory.from_value}
                  //         </span>
                  //         <span className="font-normal"> to&nbsp;</span>
                  //         <span className="font-bold whitespace-nowrap text-neutral-900 text-sm">
                  //           {eachHistory.to_value}
                  //         </span>
                  //       </div>
                  //     )}
                  //   </div>
                  // </Fragment>
                  ""
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </Fragment>
  );
};
export default OffsetVersionHistory;
